import {
  InsuranceCoverageMonitorSettings,
  InsuranceCoverageSource
} from "../../../../../services/api/insurance/monitor/types";

export const selectorIsAcceptedSourceTypeIncluded = (
  acceptedSourceType: InsuranceCoverageSource,
  insuranceCoverageMonitorSettings?: InsuranceCoverageMonitorSettings
) => {
  return insuranceCoverageMonitorSettings?.coverages?.some(coverage =>
    coverage.acceptedSourceTypes?.includes(acceptedSourceType)
  );
};
